<template>
  <div class="pcb-products">
    <select-input
      v-if="products.length"
      :options="getProductKinds"
      :get-value="getCurrentProductKind"
      label="Choose Category"
      @change="handleProductKindChange"
      name="product-kind"
      class="pcb-products-select"
    />

    <div class="pcb-products-header f aic" :style="{ 'top': headerHeight }">
      <h2 class="h5 uppercase menu-label">Choose:</h2>
      <a
        href="#"
        class="h5 uppercase pcb-products-header-item"
        v-for="productKind in productKinds"
        :key="productKind"
        :aria-label="productKind + ' - click to scroll to products of this type'"
        @click.prevent="setActiveKind(productKind)"
        :class="{'is-active': activeProductKind === productKind}"
        v-html="productKind">
      </a>
    </div>

    <pcb-products-list
      v-for="(kind, index) in productKinds"
      :key="kind"
      :products="productKindMap[kind]"
      :kind="kind"
      :show-upsell-box="index === 0"
      :ref="kind"
      :bundle="bundle"
      @in-view="onKindEnter"
    />
    <transition name="fade-in-down">
      <div class="loader-overlay" v-if="loading">
        <div class="loader loader-circle">
          <div class="loader__icon">
            <span class="spinner spinner--abs spinner--lg is-active"></span>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import request from 'axios'
import 'modules/select-input/select-input.vue'
import { handleize } from 'lib/util'
import state from 'lib/appState'
import PcbProductsList from 'modules/pcb-products-list/pcb-products-list.vue'
import animateScrollTo from 'animated-scroll-to'
import select from 'dom-select'
import { isOver } from 'lib/util'

const BREAKPOINT = 767
const HEADER_SELECTOR = '.js-header'

export default {
  props: [
    'collectionHandle',
    'bundle'
  ],
  components: {
    PcbProductsList
  },
  data () {
    return {
      state,
      loading: true,
      activeProductKind: null,
      orderList: ["Bars", "Hunks", "Gems", "Crackers"],
      headerHeight: 0
    }
  },
  async created () {
    const tags = ['tag:custom-bundle']
    const { data: { results = [] } } = await request.get(`/search`, {
      params: {
        q: `(${tags.join(' AND ')})`,
        type: 'product',
        view: 'bundle-products'
      }
    })
    this.state.bundleProducts = results
    this.loading = false
    if (isOver(BREAKPOINT)) {
      this.activeProductKind = this.productKinds[0]
    }
  },
  computed: {
    products () {
      return this.state.bundleProducts
    },
    productKinds: function () {
      return this.sortProductsByName(this.products, this.orderList)
    },
    productKindMap () {
      return this.products.reduce((productMap, product) => {
        if (productMap[product.type]) {
          productMap[product.type].push(product)
        } else {
          productMap[product.type] = [product]
        }

        return productMap
      }, {})
    }
  },
  methods: {
    setActiveKind (kind) {
      const destination = this.$refs[kind][0].$el
      if (destination) {
        animateScrollTo(destination, {
          cancelOnUserAction: false,
          offset: (select('#header').offsetHeight * -1) + (-1 * window.innerHeight * 0.25)
        })
        this.activeProductKind = kind
        destination.setAttribute('tabindex', '-1')
        destination.focus()
      }
    },
    onKindEnter (kind) {
      this.activeProductKind = kind
    },
    getProductKinds () {
      return this.productKinds.map((kind) => {
        return {
          label: kind,
          value: kind
        }
      })
    },
    getCurrentProductKind () {
      return this.activeProductKind
    },
    handleProductKindChange ({ value }) {
      this.setActiveKind(value)
    },
    sortProductsByName(products, arrayName) {
      let list = []
      if (products && arrayName) {
        arrayName.forEach(function (name) {
          products.forEach(function (product) {
            if (product.type.charAt(0) !== name.charAt(0)) {
              return;
            }
            list.push(product.type)
          })
        })
      }
      return Array.from(new Set(list))
    },
    resizeHandler () {
      const headerEl = select(HEADER_SELECTOR)
      this.headerHeight = `${headerEl ? headerEl.clientHeight : 0}px`
    }
  },
  mounted () {
    this.resizeHandler()
    window.addEventListener('resize', this.resizeHandler)
  },
  destroyed () {
    window.removeEventListener('resize', this.resizeHandler)
  }
}
</script>
